import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { mapper } from '@/mappers'
import { housesMap } from '@/mappers/house'
import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { IHouse } from '@/types/houses'

// const detachModule = (houseId: number, moid: number, module: string) => {
//   return axios.post(urlBuilder(Endpoints.DETACH_MODULE, houseId.toString()), { moid: moid, module: module })
//     .then(mapperResponse(housesMap))
// }

const detachModule = (houseId: number, moid: number, module: string) => {
  return new AxiosRequestBuilder<IHouse>({
    url: urlBuilder(Endpoints.DETACH_MODULE, String(houseId), String(moid), module),
    method: 'post',
    data: { moid: moid, module: module },
    responseMapperFunction: mapper,
    responseMapper: housesMap
  }).exec().then(res => res.data)
}

export default detachModule
